import type { AuditLog } from '@/types';

// Display labels only: stored command identifiers remain available for filtering.
const HIRING_ACTION_LABELS: Record<string, string> = {
  'hire.templates.create': 'Position Template Created',
  'hire.templates.update': 'Position Template Updated',
  'hire.jobs.create': 'Job Posting Created',
  'hire.jobs.update': 'Job Posting Updated',
  'hire.jobs.publish': 'Job Posting Published',
  'hire.jobs.pause': 'Job Posting Paused',
  'hire.jobs.close': 'Job Posting Closed',
  'hire.jobs.archive': 'Job Posting Archived',
  'hire.jobs.reopen': 'Job Posting Reopened',
  'hire.jobs.clone': 'Job Posting Duplicated',
  'hire.applications.decision': 'Application Decision Updated',
  'hire.applications.notes': 'Application Note Added',
  'hire.cases.hiring-review': 'Hiring Review Started',
  'hire.cases.create': 'Hiring Review Created',
  'hire.cases.update': 'Hiring Review Updated',
  'hire.cases.submit': 'Hiring Review Submitted',
  'hire.cases.approve': 'Hire Approved',
  'hire.cases.withdraw': 'Hiring Review Withdrawn',
  'hire.cases.checklist': 'Onboarding Checklist Created',
  'hire.cases.task': 'Onboarding Task Updated',
  'hire.applications.replacement-start': 'Resume Replacement Started',
  'hire.applications.replacement-complete': 'Resume Replacement Uploaded',
  'hire.application_files.rescan-start': 'Resume Rescan Started',
  'hire.application_files.rescan': 'Resume Rescanned',
  'hire.application_files.download': 'Resume Downloaded',
};

export function formatAuditAction(action: string): string {
  if (!action) return '';
  if (Object.prototype.hasOwnProperty.call(HIRING_ACTION_LABELS, action)) return HIRING_ACTION_LABELS[action];
  if (action.includes(' ')) return action;
  return action.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export function matchesAuditSearch(log: Pick<AuditLog, 'action' | 'details' | 'user' | 'name'>, searchTerm: string): boolean {
  const term = searchTerm.toLowerCase();
  return [log.action, formatAuditAction(log.action), log.details, log.user, log.name]
    .some(value => (value || '').toLowerCase().includes(term));
}

export function formatAuditContact(log: Pick<AuditLog, 'user' | 'name'>): string {
  // The API can fall back to a resolved name when no email was recorded.
  if (log.name && (log.user === log.name || log.user === 'Unknown')) return '';
  return log.user || '';
}

export function mergeAuditNotifications(cached: AuditLog[], fresh: AuditLog[]): AuditLog[] {
  // Authoritative API rows replace old cached actor names, including matching IDs.
  const byId = new Map([...cached, ...fresh].map(log => [log.id, log]));
  return [...byId.values()]
    .sort((a, b) => (Date.parse(b.timestamp) || 0) - (Date.parse(a.timestamp) || 0))
    .slice(0, 50);
}
